import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FeatureInfoPoint } from 'projects/leaflet/src/lib/interfaces/feature-info-point';
import { PlatformsInfoPopupService } from './platforms-info-popup.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SafePipe } from '../../pipe/safe.pipe';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'emodnet-fe-platforms-info-popup',
  templateUrl: './platforms-info-popup.component.html',
  styleUrls: ['./platforms-info-popup.component.scss']
})
export class PlatformsInfoPopupComponent implements OnInit {

  public featureInfo: any[] = [];
  public lat: string = '';
  public lng: string = '';
  public currentIndex: number = 1;
  public platformpageEmodnet: string = 'https://map.emodnet-physics.eu/platformpage/?platformcode={{@CODE}}&source=cp&integrator={{@INTEGRATOR}}';
  public isResizing: boolean = false;
  public initialWidth: number = 0;
  public initialHeight: number = 0;

  @Input() loading: boolean = true;
  @Output() closePressed = new EventEmitter<boolean>();
  constructor(private platformInfoService: PlatformsInfoPopupService, private sanitizer: DomSanitizer, public safe: SafePipe, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.platformInfoService.platformInfoChanged.subscribe((x: FeatureInfoPoint) => {
      this.featureInfo = [];
      const features = x.featureInfo
      if (features.length > 0) {
        this.currentIndex = 0;
        for (let i = 0; i < features.length; i++) {
          const feature = features[i];
          feature.properties["index"] = i;
          if (feature.properties['spatialExtent']) {
            const spatial = JSON.parse(feature.properties['spatialExtent']);
            feature.properties['north'] = spatial['northBoundLatitude'];
            feature.properties['west'] = spatial['westBoundLongitude'];
            feature.properties['east'] = spatial['eastBoundLongitude'];
            feature.properties['south'] = spatial['southBoundLatitude'];
          }
          feature.properties['climateSphere'] = JSON.parse(feature.properties['climateSpheres']);

          this.featureInfo.push(feature.properties);
        }
      } else {
        this.featureInfo = [];
        this.closePressed.emit(true);
        this.close();
      }
    });
  }

  public close() {
    this.closePressed.emit(true);
    setTimeout(() => {
      const element = document.getElementById('content');
      const popup = document.getElementById('popup-info');
      if (element && popup) {
        element.style.width = '300px';
        element.style.height = '530px';
        popup.style.width = 'fit-content';
      }
    }, 1000);
  }


  public resizeElement(): void {
    const resizer = document.getElementById('resizeIcon');
    const element = document.getElementById('content');
    const iframe = document.getElementById('iframe');
    const popup = document.getElementById('popup-info');

    if (!resizer || !element || !iframe || !popup) return;
    resizer.onmousedown = ((e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      this.isResizing = true;
      this.initialWidth = element.clientWidth;
      this.initialHeight = element.clientHeight;

      document.onmousemove = ((e: MouseEvent) => {
        if (!this.isResizing) return;
        if (e.clientX > window.innerWidth) return; // prevent from going out of the screen (width)
        if (e.clientY > window.innerHeight) return; // prevent from going out of the screen (height)

        const newWidth = this.initialWidth + e.movementX;
        const newHeight = this.initialHeight + e.movementY;
        if (newWidth <= 300) return;
        this.initialWidth = newWidth;
        this.initialHeight = newHeight;

        element.style.width = newWidth + 'px';
        element.style.height = newHeight + 'px';
        iframe.style.height = '90%';
        popup.style.width = newWidth + 'px';
        popup.style.height = newHeight + 'px';
      });
      document.onmouseup = (() => {
        this.isResizing = false;
        document.onmouseup = null;
        document.onmousemove = null;
      });

    });

  }

  public selectNewIframe(event: any) {
    this.currentIndex = event.value
  }
}
